import React, { useState, useEffect } from "react";
import Popup from "./Popup";
import Form from "../FormUi/Form";
import { lowerCase } from "lodash";

import { Field } from "../Types/Form";
import { IPopupProps } from "../Common/types";

import useFetchPost from "../Hooks/useFetchPost";
import Loading from "../Ui/Loading";



// Компонент предназначен только для попапов, которые содержат в себе форму
// В пропасх передается массив fields, что из себя представляет fields можно прочесть в компоненте Form.tsx
// url - ссылка, апи бота телеграма для отправки сообщений в канал
// chatId - айди чата
type props = IPopupProps & {
    fields: Field[],
    url: string,
    chatId: number;
    noteText?: string;
}

const FormPopup = ({ fields, isOpen, close, head, url, chatId, noteText }: props) => {
    const [loading, setLoading] = useState(false);
    const [isFinally, setIsFinally] = useState(false);

    const [popupHead, setPopupHead] = useState(head);

    const sendData = (data) => {
        const dataToSend = Object.keys(data).map(key => {
            return { [String(fields.find(item => item.name == key).title)]: data[key] }
        })

        let resultText = dataToSend
            .map(item => {
                const key = Object.keys(item)[0];
                const value = item[key];
                return `${key}: ${value}`;
            })
            .join('\n');

        resultText += `\n Страница: ${window.location.href} \n`
        if (noteText) resultText += `Примечание: ${noteText} \n`

        console.log(resultText);
        useFetchPost({
            apiUrl: url,
            data: { chat_id: chatId, text: resultText },
            onLoading: (bool) => setLoading(bool),
            onError: (text) => {
                setPopupHead({ title: "Ошибка", description: "Произошла ошибка, попробуйте позже" });
                setIsFinally(true);
            },
            onResult: () => {
                setPopupHead({ title: "Успех", description: "Сообщение успешно отправлено" });
                setIsFinally(true);
            }
        })
    }

    const renderBody = () => {
        return (
            <Form
                fields={fields}
                handleSubmit={sendData}
            />
        )
    };

    return (
        <>
            <Popup
                isOpen={isOpen}
                close={() => { close(); setIsFinally(false); setPopupHead(head) }}
                head={popupHead}
                body={renderBody()}
                loading={loading}
                isFinally={isFinally}
            />
        </>
    )
}

export default FormPopup;